export const DEFAULT_ACCOUNTABILITY_COPY = {
  heroTitle: "Do the work.\nBe the standard.",
  heroBody: "Small actions every day. Big results on game day.",
  commitmentTitle: "Explode first step.\nStay low.",
  commitmentSubtitle: "This is your focus this week.",
  checkInQuestion: "How did you show up today?",
  notePlaceholder:
    "Honestly—where is your head mentally right now, and how did that affect how you showed up today?",
};

export const ACCOUNTABILITY_COPY_FIELDS = [
  { key: "heroTitle", label: "Hero title", hint: "One line per title line", rows: 2 },
  { key: "heroBody", label: "Hero body", rows: 2 },
  { key: "commitmentTitle", label: "Today's commitment title", hint: "One line per title line", rows: 2 },
  { key: "commitmentSubtitle", label: "Commitment subtitle", rows: 2 },
  { key: "checkInQuestion", label: "Daily check-in question", rows: 2 },
  { key: "notePlaceholder", label: "Note placeholder", rows: 3 },
];

export const mergeAccountabilityCopy = (raw = {}) =>
  Object.keys(DEFAULT_ACCOUNTABILITY_COPY).reduce((acc, key) => {
    const next = String(raw[key] ?? "").trim();
    acc[key] = next || DEFAULT_ACCOUNTABILITY_COPY[key];
    return acc;
  }, {});
